import { ref } from 'vue'
export default function () {
  const legends = ref([])

  return {
    legends,
  }
}
